import { render, staticRenderFns } from "./AssistantPromotions.vue?vue&type=template&id=7899c228&scoped=true"
import script from "./AssistantPromotions.vue?vue&type=script&lang=js"
export * from "./AssistantPromotions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7899c228",
  null
  
)

export default component.exports